import React from 'react';
import { Box, Modal, Portal, IconButton, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PDFPreviewModal = ({ url, handleClose }) => {
  const isMobile = useMediaQuery('(max-width: 600px)');

  return (
    <Portal>
      <Modal open={true}>
        <Box
          style={{
            width: '100vw',
            height: '100vh',
            overflow: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: isMobile ? '10px' : '20px',
            backgroundColor: 'rgba(0, 0, 0, 0.7)' // Dodanie lekkiego przyciemnienia tła
          }}
        >
          <iframe
            src={url}
            style={{
              border: 'none',
              width: isMobile ? '95%' : '80%',
              height: isMobile ? '85%' : '90%',
              maxWidth: '100%',
              maxHeight: '100%'
            }}
          ></iframe>

          <IconButton
            style={{
              position: 'fixed',
              top: isMobile ? '10px' : '20px',
              right: isMobile ? '10px' : '20px',
              backgroundColor: 'rgba(255, 255, 255, 0.8)'
            }}
            onClick={handleClose}
            color="primary"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Modal>
    </Portal>
  );
};

export default PDFPreviewModal;
